import type { ReactNode } from 'react';
import React from 'react';
import { Stack } from '@balance-web/stack';
import type { WithDataAttributeProp } from '@balance-web/core';

import { Header } from './Header';
import { Body } from './Body';
import { Footer } from './Footer';
import { Form } from './Form';

export const PopoverContent = ({
  children,
  ...props
}: WithDataAttributeProp<{ children: ReactNode }>) => {
  return <Stack {...props}>{children}</Stack>;
};

PopoverContent.Header = Header;
PopoverContent.Body = Body;
PopoverContent.Form = Form;
PopoverContent.Footer = Footer;
